import httpClient from "@/httpClient"

export const getUserAccount = () => httpClient.get(`/user/profile`)

export const loadFavoriteViews = () => httpClient.get(`/filter-views/favourites`)
